import { initializeNativeBridge } from '@forest/native-services'
import { appVersion, language } from './lib/params'
import { overwriteGetLocale, type Locale } from './paraglide/runtime'

overwriteGetLocale(() => language as Locale)

initializeNativeBridge({
  appVersion,
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})
